import { ADDITIONAL_ICONS } from './additional_icons'
import { COMMON_ICONS } from './common_icons'
import { INITIAL_ICONS } from './initial_icons'

export const ICONS = {
  ...INITIAL_ICONS,
  ...COMMON_ICONS,
  ...ADDITIONAL_ICONS,
}
